import React from "react";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#204613] text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12 mb-10 sm:mb-12">
          <div>
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/logo-3noFyvW6BAngDo932m1D4AElcp6UDa.png"
              alt="Mesquita Psiquiatria"
              className="h-10 sm:h-12 w-auto mb-5"
              style={{ filter: "brightness(2)" }}
            />
            <p className="font-serif text-sm text-white/70 leading-relaxed">
              Psiquiatria e psicoterapia humanizadas. Ciência, sensibilidade e mais de 30 anos de experiência cuidando da saúde mental.
            </p>
          </div>

          <div>
            <h4 className="font-sans text-base sm:text-lg font-semibold mb-4 sm:mb-5 text-[#C2A44A]">Navegação</h4>
            <ul className="flex flex-col gap-2 sm:gap-3 font-serif text-sm">
              {[
                { label: "Home", href: "#home" },
                { label: "Sobre", href: "#sobre" },
                { label: "Abordagem", href: "#abordagem" },
                { label: "Tratamentos", href: "#tratamentos" },
                { label: "Depoimentos", href: "#depoimentos" },
                { label: "Equipe", href: "#equipe" },
                { label: "Espaço", href: "#espaco" },
                { label: "Conteúdos", href: "#conteudos" },
                { label: "Contato", href: "#contato" },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-white/70 hover:text-white transition-colors duration-200">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-base sm:text-lg font-semibold mb-4 sm:mb-5 text-[#C2A44A]">Contato</h4>
            <div className="flex flex-col gap-4 font-serif text-sm text-white/70">
              <a
                href="https://wa.me/5548992100333"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 hover:text-white transition-colors"
              >
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>+55 48 99210-0333 (WhatsApp)</span>
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>
                  Square SC<br />
                  Rod. José Carlos Daux, 5500<br />
                  Torre Campeche A, sl 316<br />
                  Bairro Saco Grande - Florianópolis/SC<br />
                  CEP: 88032-005
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            <p className="font-serif text-xs sm:text-sm text-white/50">
              &copy; 2026 Mesquita Psiquiatria e Psicoterapia. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 font-serif text-xs sm:text-sm text-white/50">
              <a href="#" className="hover:text-white/70 transition-colors">Política de Privacidade</a>
              <span>|</span>
              <a href="#" className="hover:text-white/70 transition-colors">Termos de Uso</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
